import styled from 'styled-components';

const HeatRecoveryWrapper = styled.div``;

export { HeatRecoveryWrapper };
